import Nullstack from 'nullstack';
export default function IconBrandMailgun({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-mailgun",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M17 12a2 2 0 1 0 4 0a9 9 0 1 0 -2.987 6.697"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "5"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "1"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "1"
  }), " ");
}